import React, { useState, useEffect, useRef } from "react";
import { useProfileApi } from "../Services/api/profileApi";
import { useMomApi } from "../Services/api/momApi";
import { useBalanceSheetApi } from "../Services/api/balanceSheetApi";
import { useCommentsApi } from "../Services/api/commentsApi";
import { useDownloadApi } from "../Services/api/downloadApi";
import useLocalStorage from "../hooks/useLocalStorage";
import { useLoader } from "../components/common/LoaderContext";
import useSilentIdTokenRefresh from "../msal/useSilentTokenRefresh";
import { useAppContext } from "../hooks/context/AppContext";
import { errorToast, successToast } from "../Utils/toast";
import { buildParams } from "../Utils/buildParams";
import { AuditData, TableRowData, TotalAmountData } from "../types/table";
import { useDropdowns } from "../hooks/useDropdowns";
import { AdvancedFilters } from "../types/filters";
import { useHeader } from "../hooks/context/HeaderContext";
import { useQueryParams } from "../hooks/useQueryParams";
import PrimaryLandscapeComments from "./PrimaryLandscapeComments";
// import SecondaryLandscapeComments from "./SecondaryLandscapeComments";

export function convertKeysToString(input: any) {
  return input.map((item: any) => {
    return {
      key: item.key.toString(),
      value: item.value,
    };
  });
}

const Comments: React.FC = () => {
  const { updateHeaderInfo } = useHeader();
  const { getProfile } = useProfileApi();
  const { getMomData } = useMomApi();
  const { getBalanceSheetResult } = useBalanceSheetApi();
  const { savePaginatedComments, saveDraft, submitForReview } =
    useCommentsApi();
  const { downloadCsv } = useDownloadApi();
  const { loading, setLoading } = useLoader();
  const [userInfo, setUserInfo] = useLocalStorage("user_info", null);
  const [isValidUser, setisValidUser] = useState(true);
  const [idToken, setIdToken] = useState(null);
  const [, setAuthData] = useLocalStorage("auth_data", null);
  const { userData, updateUserData, authData, updateAuthData } =
    useAppContext();
  const [isConfirming, setIsConfirming] = useState(false);
  const [filtersChanged, setFiltersChanged] = useState(false);
  const [isSubmitForReviewStarted, setIsSubmitForReviewStarted] =
    useState(false);
  const { getQueryParams } = useQueryParams();
  const queryParams = getQueryParams();
  const landscapeId =
    queryParams.LandscapeID === ""
      ? userData?.LandscapeInfo && userData.LandscapeInfo.length > 0
        ? userData.LandscapeInfo[0]?.LandscapeId
        : undefined
      : queryParams.LandscapeID;
  const CBTType = queryParams.CBTType || "";

  const handleFilterChangeWithWarning = (
    key: keyof AdvancedFilters,
    value: string | string[],
  ) => {
    setFiltersChanged(true);
    if (commentsArray.length > 0 && !isConfirming) {
      setPendingChange({ key, value });
      setShowWarningModal(true);
      return false;
    }
    // Proceed with the change
    return true;
  };
  const [currency, setCurrency] = useState("LC"); // Local Currency
  const [order, setOrder] = useState<string>("asc");
  const [orderBy, setOrderBy] = useState("REPORTING_GROUP");
  const { filters, dropdownOptions, thresholdValues, handleFilterChange } =
    useDropdowns(userData, handleFilterChangeWithWarning, setCurrency);
  const [currencyMode, setCurrencyMode] = useState("local");
  const [tableData, setTableData] = useState<TableRowData[]>([]);
  const [cbtTypeOptions, setCbtTypeOptions] = useState<any[]>([
    {
      CBTTypes_Data: "",
    },
  ]);
  const [companyCodeOptions, setCompanyCodeOptions] = useState<any[]>([
    {
      CompanyCode: "",
    },
  ]); 
  const [reportingGroupOptions, setReportingGroupOptions] = useState<any[]>([
    {
      ReportingGroup: "",
    },
  ]);
  const [L3CodeOptions, setL3CodeOptions] = useState<any[]>([
    {
      L3Code: "",
    },
  ]);
  const [cbtFilter, setCbtFilter] = useState<string>("All");
  const [companyFilter, setCompanyFilter] = useState<string>("All");
  const [glFilter, setGlFilter] = useState<string>("All");
  const [rgFilter, setRgFilter] = useState<string>("All");
  // const skipFilterEffect = useRef(false);
  const [isSignedOff, setIsSignedOff] = useState(false);
  const [auditData, setAuditData] = useState<AuditData[]>([
    {
      ValidationMessage: "",
      EnablePage: true,
      SubmittedBy: "",
      SubmittedDate: "",
      SignOffBy: "",
      SignOffDate: "",
      TotalRecords: 0,
      CommentsStatusID: 0,
    },
  ]);
  const [totalAmountData, setTotalAmountData] = useState<TotalAmountData[]>([
    {
      TotalReportingValue: 0,
      TotalComparisonValue: 0,
    },
  ]);
  const [page, setPage] = useState(0);
  const [tableLoading, setTableLoading] = useState(false);
  const [openDraftDialog, setOpenDraftDialog] = useState(false);
  const [dialogAction, setDialogAction] = useState<"draft" | "review" | null>(
    null,
  );
  const [openMomDialog, setOpenMomDialog] = useState(false);
  const [momData, setMomData] = useState([
    { MOM: "", SubmittedBy: "", submittedDate: "" },
  ]);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [pendingChange, setPendingChange] = useState<{
    key: keyof AdvancedFilters;
    value: string | string[];
  } | null>(null);

  const getIdTokenSilently = useSilentIdTokenRefresh(
    (token: any | null, account: any | null) => {
      if (token && account) {
        setIdToken(token);
        const updatedAuthData = {
          ...authData,
          idToken: token,
          name: account.name || authData.name,
          username: account.username || authData.username,
          homeAccountId: account.homeAccountId || authData.homeAccountId,
          environment: account.environment || authData.environment,
          tenantId: account.tenantId || authData.tenantId,
          localAccountId: account.localAccountId || authData.localAccountId,
        };

        updateAuthData(updatedAuthData);
        setAuthData(JSON.stringify(updatedAuthData));
      }
    },
  );
  const [validationErrors, setValidationErrors] = useState<
    Record<string, boolean>
  >({
    marketvalue: false,
    mco: false, // Start with true since initially empty
    country: false,
    reportingyear: false,
    comparisonyear: false,
    reviewscenario: false,
    companycodes: false,
    reportingmonth: false,
    comparisonmonth: false,
    currency: false,
  });
  const [commentsArray, setCommentsArray] = useState<number[]>([]);
  const validateAndFetchTableData = (
    typeOfAction: string,
    extraFilters?: {
      cbtFilter?: string;
      companyFilter?: string;
      glFilter?: string;
      rgFilter?: string;
    },
  ) => {
    console.log(typeOfAction, "typeOfAction");
    const hasRequiredFilters =
      filters.country &&
      filters.companycodes &&
      filters.companycodes.length > 0 &&
      filters.mco &&
      filters.marketvalue &&
      filters.reviewscenario;
    if (hasRequiredFilters) {
      fetchTableData(typeOfAction, extraFilters);
    }
  };

  //effect to only set the landscape name in the header
  useEffect(() => {
    const selectedLandscape = userData.LandscapeInfo?.find(
      (l: any) => String(l.LandscapeId) === String(landscapeId),
    );
    updateHeaderInfo({
      landscapeName: selectedLandscape ? selectedLandscape.LandscapeName : "",
    });
  }, [landscapeId]);

  //effect to validate and fetch table data
  useEffect(() => {
    validateAndFetchTableData("GO");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currencyMode, order, orderBy]);

  // Effect to fetch table data when comments are added
  useEffect(() => {
    proceedWithClearComment();
    // validateAndFetchTableData();
  }, [commentsArray.length]);

  // Effect to handle page change in the table
  useEffect(() => {
    const extraFilters: {
      cbtFilter?: string;
      companyFilter?: string;
      glFilter?: string;
      rgFilter?: string;
    } = {};
    if (cbtFilter && cbtFilter !== "All") extraFilters.cbtFilter = cbtFilter;
    if (companyFilter && companyFilter !== "All")
      extraFilters.companyFilter = companyFilter;
    if (glFilter && glFilter !== "All") extraFilters.glFilter = glFilter;
    if (rgFilter && rgFilter !== "All") extraFilters.rgFilter = rgFilter;
    if (isSubmitForReviewStarted) {
      saveAsDraft("SUBMIT_FOR_REVIEW");
    } else {
      if (commentsArray.length > 0) {
        saveComments("Pagination", extraFilters);
      } else {
        validateAndFetchTableData("GO", extraFilters);
      }
    }
  }, [page]);

  useEffect(() => {
    const fetchMomData = async () => {
      const params = {
        ...buildParams(
          filters,
          userData,
          currency,
          page,
          order,
          orderBy,
          landscapeId,
          CBTType,
          currencyMode,
        ),
        CurrencyCode: currencyMode === "euro" ? "euro" : currency,
        ReviewScenarioID: filters.reviewscenario,
        SortByColumnKey: orderBy,
        SortOrder: orderBy,
        CBTType: CBTType || "",
        SearchCBTType: cbtFilter || "ALL",
        SearchCompanyCode: companyFilter || "ALL",
        SearchL3Code: glFilter || "ALL",
        SearchReportingGroup: rgFilter || "ALL",
        TypeOfAction: "GO",
      };
      if (tableData.length > 0) {
        const response = await getMomData(params);
        if (response) {
          setMomData(response);
        }
      }
    };
    fetchMomData();
  }, [openMomDialog]);
  // function to fetch the table data
  const fetchTableData = async (
    typeOfAction: string,
    extraFilters?: {
      cbtFilter?: string;
      companyFilter?: string;
      glFilter?: string;
      rgFilter?: string;
    },
  ) => {
    setLoading(true);
    const baseParams = buildParams(
      filters,
      userData,
      currency,
      page,
      order,
      orderBy,
      landscapeId,
      CBTType,
      currencyMode,
    );
    const cbtVal = extraFilters?.cbtFilter ?? "All";
    const companyVal = extraFilters?.companyFilter ?? "All";
    const glVal = extraFilters?.glFilter ?? "All";
    const rgVal = extraFilters?.rgFilter ?? "All";

    const extendedParams = {
      ...baseParams,
      typeOfAction: typeOfAction,
      SearchCBTType: cbtVal,
      SearchCompanyCode: companyVal,
      SearchL3Code: glVal,
      SearchReportingGroup: rgVal,
    };

    let response = await getBalanceSheetResult(extendedParams);
    if (response) {
      const auditItem =
        Array.isArray(response.Paginated_AuditData) &&
        response.Paginated_AuditData.length > 0
          ? response.Paginated_AuditData[0]
          : undefined;
      setTableData(
        (response.Data || []).map((row: TableRowData) => ({
          ...row,
          OldComments: row.Comments ?? "",
        })),
      );
      setAuditData(response.Paginated_AuditData);
      setCbtTypeOptions(response.CBTTypes_Data);
      setCompanyCodeOptions(response.CompanyCode_Data);
      setReportingGroupOptions(response.L3Description_Data);
      setL3CodeOptions(response.L3Code_Data);
      setTotalAmountData(
        response.TotalAmount_Data || [
          { TotalReportingValue: 0, TotalComparisonValue: 0 },
        ],
      );
      if (!auditItem.EnablePage) {
        setIsSignedOff(true);
      } else {
        setFiltersChanged(false);
        setIsSignedOff(false);
      }
      updateHeaderInfo({
        submittedBy: auditItem.SubmittedBy,
        submittedDate: auditItem.SubmittedDate,
        signOffBy: auditItem.SignOffBy,
        signOffDate: auditItem.SignOffDate,
        commentStatus: auditItem.CommentsStatus,
        refreshDate: auditItem.refreshDate,
      });
    }

    setLoading(false);
  };

  //effect to fetch user profile on component mount or when authData changes
  useEffect(() => {
    if (authData.idToken && !userData.UserID) {
      setLoading(true);
      fetchUserProfile();
    }
  }, [authData, userData.UserID]);

  // Function to handle the click of the save the paginated comments
  const saveComments = async (
    TypeOfAction: string,
    extraFilters: {
      cbtFilter?: string;
      companyFilter?: string;
      glFilter?: string;
    },
  ) => {
    setLoading(true);
    const arr = tableData.map((row) => {
      return {
        CompanyId: row?.CompanyID || 0,
        CommentsID: row?.CommentsID || 0,
        Comments: row?.Comments || "",
        OldComments: row?.OldComments || "",
      };
    });
    const extendedParams = {
      ...buildParams(
        filters,
        userData,
        currency,
        page,
        order,
        orderBy,
        landscapeId,
        CBTType,
        currencyMode,
      ),
      TypeOfAction: TypeOfAction,
      Comments: arr,
    };
    if (tableData.length > 0) {
      try {
        const response = await savePaginatedComments(extendedParams);
        if (response) {
          setCommentsArray([]);
          successToast("Comments saved successfully!");
          validateAndFetchTableData("GO", extraFilters);
        }
      } catch (error) {
        errorToast("Error saving comments.");
        console.error("Error saving comments:", error);
      }
    } else {
      errorToast("No data available to save comments.");
    }
    setLoading(false);
  };

  // Function to handle the click of the save as draft or submit for review
  const saveAsDraft = async (TypeOfAction: string) => {
    setLoading(true);
    const arr = tableData.map((row) => {
      return {
        CompanyId: row?.CompanyID || 0,
        CommentsID: row?.CommentsID || 0,
        Comments: row?.Comments || "",
        OldComments: row?.OldComments || "",
      };
    });
    const extendedParams = {
      ...buildParams(
        filters,
        userData,
        currency,
        page,
        order,
        orderBy,
        landscapeId,
        CBTType,
        currencyMode,
      ),
      TypeOfAction: TypeOfAction,
      Comments: arr,
    };
    if (tableData.length > 0) {
      try {
        let response;
        switch (TypeOfAction) {
          case "SAVE_AS_DRAFT":
            response = await saveDraft(extendedParams);
            if (response) {
              setCommentsArray([]);
              setIsSubmitForReviewStarted(false);
              successToast("Comments saved as Draft successfully!");
              validateAndFetchTableData("GO");
            }
            break;
          case "SUBMIT_FOR_REVIEW":
            response = await submitForReview(extendedParams);
            if (response) {
              setCommentsArray([]);
              setIsSubmitForReviewStarted(true);
              if (response.Data.length === 0) {
                // setTableData([]);
                successToast(response.Paginated_AuditData[0].ValidationMessage);
                validateAndFetchTableData("GO");
              } else {
                setTableData(response.Data);
              }
              if (response.Paginated_AuditData[0].validationErrors === "") {
                successToast("Comments submitted for review successfully!");
              }
              setAuditData(response.Paginated_AuditData);
              setTotalAmountData(
                response.TotalAmount_Data || [
                  { TotalReportingValue: 0, TotalComparisonValue: 0 },
                ],
              );
              if (!response.Paginated_AuditData[0].EnablePage) {
                setIsSignedOff(true);
              }
            }
            break;
          default:
            errorToast("Invalid action type");
            break;
        }
        if (response) {
          setCommentsArray([]);
        }
      } catch (error) {
        errorToast("Error saving comments.");
        console.error("Error saving comments:", error);
      }
    } else {
      errorToast("No data available to save comments.");
    }
    setLoading(false);
  };

  const handleTableFilterChange = (
    value: string,
    filterType: "cbtFilter" | "companyFilter" | "glFilter" | "rgFilter",
  ) => {
    switch (filterType) {
      case "cbtFilter":
        setCbtFilter(value);
        break;
      case "companyFilter":
        setCompanyFilter(value);
        break;
      case "glFilter":
        setGlFilter(value);
        break;
      case "rgFilter":
        setRgFilter(value);
        break;

      default:
        break;
    }
  };
  useEffect(() => {
    const extraFilters: {
      cbtFilter?: string;
      companyFilter?: string;
      glFilter?: string;
      rgFilter?: string;
    } = {};
    if (cbtFilter) extraFilters.cbtFilter = cbtFilter;
    if (companyFilter) extraFilters.companyFilter = companyFilter;
    if (glFilter) extraFilters.glFilter = glFilter;
    if (rgFilter) extraFilters.rgFilter = rgFilter; 
    if (
      Object.keys(extraFilters).length > 0 &&
      companyCodeOptions[0].CompanyCode.length > 0
    ) {
      fetchTableData("GO", extraFilters);
    }
    setPage(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cbtFilter, companyFilter, glFilter, rgFilter]);

  // Fetch user profile and update user data
  // This function is called when the component mounts or when authData changes
  let fetchUserProfile = async () => {
    setLoading(true);
    try {
      let res = await getProfile();
      if (res) {
        setUserInfo(JSON.stringify(res));
        updateUserData(res);
      }
    } catch (err) {
      setisValidUser(false);
      console.error("Failed to fetch user profile", err);
      errorToast("Failed to fetch user profile");
    } finally {
      setLoading(false);
    }
  };

  // Function to handle the click of the GO button to fetcht the
  // table data based on the filters
  const handleClick = async () => {
    //setTableLoading(true);
    setFiltersChanged(false);
    setIsSubmitForReviewStarted(false);

    // skipFilterEffect.current = true;
    setCbtFilter("All");
    setCompanyFilter("All");
    setGlFilter("All");
    setRgFilter("All");
    const newValidationErrors = {
      mco: !filters.mco || filters.mco === "",
      country: !filters.country || filters.country === "",
      reportingyear: !filters.reportingyear,
      comparisonyear: !filters.comparisonyear,
      reviewscenario: !filters.reviewscenario || filters.reviewscenario === "",
      companycodes:
        !filters.companycodes ||
        (Array.isArray(filters.companycodes) &&
          filters.companycodes.length === 0),
      reportingmonth: filters.reportingmonth.toString() === "",
      comparisonmonth: filters.comparisonmonth.toString() === "",
      // rgFilter: !rgFilter || rgFilter === "",

    };

    setValidationErrors(newValidationErrors);
    setPage(0);
    const validateClick = Object.values(newValidationErrors).some(
      (item) => item,
    );
    if (validateClick || !filters.companycodes.length) {
      return;
    }
    try {
      setLoading(true);
      setTableLoading(true);
      const response = await getBalanceSheetResult({
        ...buildParams(
          filters,
          userData,
          currency,
          page,
          order,
          orderBy,
          landscapeId,
          CBTType,
          currencyMode,
        ),
        TypeOfAction: "GO",
      });
      setTableData(
        (response.Data || []).map((row: TableRowData) => ({
          ...row,
          OldComments: row.Comments ?? "",
        })),
      );
      // setTableData(response.Data);
      setAuditData(response.Paginated_AuditData);
      setCbtTypeOptions(response.CBTTypes_Data);
      setCompanyCodeOptions(response.CompanyCode_Data);
      setL3CodeOptions(response.L3Code_Data);
      setReportingGroupOptions(response.L3Description_Data);
      setTotalAmountData(
        response.TotalAmount_Data || [
          { TotalReportingValue: 0, TotalComparisonValue: 0 },
        ],
      );
      if (!response.Paginated_AuditData[0].EnablePage) {
        setIsSignedOff(true);
      } else {
        setFiltersChanged(false);
        setIsSignedOff(false);
      }
      updateHeaderInfo({
        submittedBy: response.Paginated_AuditData[0].SubmittedBy,
        submittedDate: response.Paginated_AuditData[0].SubmittedDate,
        signOffBy: response.Paginated_AuditData[0].SignOffBy,
        signOffDate: response.Paginated_AuditData[0].SignOffDate,
        commentStatus: response.Paginated_AuditData[0].CommentsStatus,
        refreshDate: response.Paginated_AuditData[0].RefreshDate,
      });
    } catch (error) {
      console.error("Failed to fetch table data:", error);
      // errorToast("Failed to fetch data");
    } finally {
      setLoading(false);
      setTableLoading(false);
      // skipFilterEffect.current = false;
    }
  };

  const closeWarningModal = () => {
    setShowWarningModal(false);
  };
  const clearComments = () => {
    setCommentsArray([]);
    closeWarningModal();
    fetchTableData("GO");
  };

  // Function to proceed with clearing comments after confirmation
  const proceedWithClearComment = () => {
    if (pendingChange) {
      handleFilterChange(pendingChange.key, pendingChange.value);
      setIsConfirming(false);
      setPendingChange(null);
    }
  };
  const renderByLandscape = () => {
 
    return (
      <PrimaryLandscapeComments
        openDraftDialog={openDraftDialog}
        setOpenDraftDialog={setOpenDraftDialog}
        saveAsDraft={saveAsDraft}
        dialogAction={dialogAction}
        openMomDialog={openMomDialog}
        setOpenMomDialog={setOpenMomDialog}
        showWarningModal={showWarningModal}
        setShowWarningModal={setShowWarningModal}
        closeWarningModal={closeWarningModal}
        clearComments={clearComments}
        validationErrors={validationErrors}
        filters={filters}
        dropdownOptions={dropdownOptions}
        handleFilterChange={handleFilterChange}
        handleClick={handleClick}
        thresholdValues={thresholdValues}
        currencyMode={currencyMode}
        setCurrencyMode={setCurrencyMode}
        currency={currency}
        userData={userData}
        page={page}
        setPage={setPage}
        order={order}
        orderBy={orderBy}
        setOrder={setOrder}
        setOrderBy={setOrderBy}
        landscapeId={landscapeId}
        CBTType={CBTType}
        tableData={tableData}
        setTableData={setTableData}
        commentsArray={commentsArray}
        setCommentsArray={setCommentsArray}
        tableLoading={tableLoading}
        auditData={auditData}
        totalAmountData={totalAmountData}
        isSignedOff={isSignedOff}
        downloadCsv={downloadCsv}
        validateAndFetchTableData={validateAndFetchTableData}
        filtersChanged={filtersChanged}
        setFiltersChanged={setFiltersChanged}
        isFilterChanged={filtersChanged}
        setDialogAction={setDialogAction}
        cbtTypeOptions={cbtTypeOptions}
        companyCodeOptions={companyCodeOptions}
        reportingGroupOptions={reportingGroupOptions} 
        L3CodeOptions={L3CodeOptions}
        cbtFilter={cbtFilter}
        setCbtFilter={setCbtFilter}
        companyFilter={companyFilter}
        setCompanyFilter={setCompanyFilter}
        glFilter={glFilter}
        setGlFilter={setGlFilter}
        rgFilter={rgFilter}
        setRgFilter={setRgFilter}
        handleTableFilterChange={handleTableFilterChange}
        momData={momData}
      />
    );
  };
  return <>{renderByLandscape()}</>;
};

export default Comments;
